import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/** Resources and read models displayed by Operations. */
const BOARD_RESOURCES = [
  "pipelines",
  "pipeline_stages",
  "pipeline_cards",
  "pipeline_cards_summary",
  "tags_summary",
  "contact_sources",
  "tasks",
];

/**
 * ra-core refreshes the caches of the resource it mutates, but the board reads
 * views (`pipeline_cards_summary`, ...) fed by other tables. Call this after
 * editing a contact, a deal, a task or a note from Operations.
 */
export const useRefreshBoard = () => {
  const queryClient = useQueryClient();
  return useCallback(
    () =>
      Promise.all(
        BOARD_RESOURCES.map((resource) =>
          queryClient.invalidateQueries({ queryKey: [resource] }),
        ),
      ),
    [queryClient],
  );
};
